<template>
    <div>
        <div :class="listContainerClasses" :style="'min-height: ' + minHeight">
            <template v-if="fetching">
                <slot name="loading"></slot>
            </template>
            <template v-else-if="recordsEmpty">
                <slot name="empty"></slot>
            </template>
            <template v-else v-for="(record) in pagination.data">
                <slot name="body" :record="record" :mixins="self" :refresh-page="refreshPage"></slot>
            </template>
        </div>
        <template scope-slot="footer">
            <pagination
                class="pt-3 pb-3"
                v-if="(pagination.last_page || pagination.last) > 1"
                :simplified="simplified"
                :total-pages="pagination.last_page || pagination.last"
                :total="pagination.total"
                :current-page="pagination.current_page"
                @pageChanged="pageChanged"
            ></pagination>
        </template>
    </div>
</template>
<script>
import mixins from "@utils/mixins";
import { get } from "@utils/network";
const Pagination = () => import("./cards/Pagination.vue");

export default {
    name: "PaginatedSection",
    components: { Pagination },

    computed: {
        displayedTitle() {
            return this.searched ? `Search results for "${ this.lastSearch }"` : this.title;
        },

        recordsEmpty() {
            return this.pagination.data && this.pagination.data.length == 0;
        },

        listContainerClasses() {
            return {
                "row": this.isRow,
            };
        },

    },

    props: {
        title: String,
        fetchLink: String,
        params: [Object],
        isRow: { type: Boolean, default: false },
        paginatePath: {
            type: String,
            default: "",
        },
        simplified: { type: Boolean, default: false },
        minHeight: String,
    },

    mixins: [mixins],

    data: () => ({
        link: "",
        fetching: true,
        currentPage: 1,
        pagination: {},
        self: {},
        search: "",
        searched: false,
        lastSearch: "",
    }),

    methods: {
        getPageClass(isActive) {
            return {
                "active": isActive,
                "page-item": true,
            };
        },
        
        startSearch() {
            this.searched = !!this.search && this.search.length > 0
            this.link = this.fetchLink;
            this.fetchData();
        },

        fetchData() {
            let params = {...this.params, page: this.currentPage};
            if (this.searched) {
                params.search = this.lastSearch = this.search;
            }
            this.fetching = true;
            get(this.link, { params })
                .then(response => this.mapData(response))
                .catch(error => this.fetchFailed(error))
                .finally(() => this.fetching = false);
        },

        fetchFailed(error) {
            this.$emit("fetch-failed", error);
            this.promptErrors(error.response.data.message);
            this.pagination = { data: [] };
        },

        mapData(response) {
            this.pagination =this.getPaginationFromPath(response);
        },

        getPaginationFromPath(data) {
            this.paginatePath.split(".").forEach(index => data = data[index]);
            return data;
        },

        refreshPage() {
            this.fetchData();
        },
        refresh() {
            this.currentPage = 1;
            this.fetchData();
        },
        pageChanged(page){
            this.$emit("page-changed", page)
            this.currentPage = page;
            this.fetchData();
        },
    },

    watch: {
        fetchLink(newValue) {
            this.link = newValue;
        },
    },
    mounted() {
        this.self = this;
        this.link = this.fetchLink;
        this.fetchData();
    },
}
</script>
